import  * as yup from "yup";

export const TreatmentInstillationSchema = yup.object({
  date: yup
  .string()
  .required("Date is required"),
});
